import { array } from 'fp-ts';
import { Banner, StackItem } from '@optimus-web/core';
import { ContentSection, SuspenseBoundary } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { PolicyException } from '../../../../types';
import { PolicyExceptionsFormStepContextProvider, useCurrentRateGroupContext } from '../../../../contexts';
import { IncompatibleIntegrationsBanner } from '../../../../../../components/common/IncompatibleIntegrationsBanner';
import { PolicyExceptionsTable } from './PolicyExceptionsTable';
import { AddPolicyExceptionButton } from './dialogTriggers';

interface PolicyExceptionsSectionProps {
    policyExceptions: Array<PolicyException>;
    editable: boolean;
}

export const PolicyExceptionsSection = ({ policyExceptions, editable }: PolicyExceptionsSectionProps) => {
    const { activeRateCount } = useCurrentRateGroupContext();
    return (
        <SuspenseBoundary loader="inline">
            {array.isNonEmpty(policyExceptions) ? (
                <StackItem>
                    <IncompatibleIntegrationsBanner />
                    <PolicyExceptionsTable policyExceptions={policyExceptions} editable={editable} />
                </StackItem>
            ) : (
                editable && (
                    <ContentSection
                        title={lt('GeneralPolicyExceptionPlural')}
                        description={lt('RateGroupPolicyExceptionsSectionDescription')}
                    >
                        <StackItem>
                            {activeRateCount ? (
                                <PolicyExceptionsFormStepContextProvider>
                                    <AddPolicyExceptionButton />
                                </PolicyExceptionsFormStepContextProvider>
                            ) : (
                                <Banner
                                    primaryText={lt('RateGroupPolicyExceptionsSectionBannerNoAssignedRates')}
                                    variant="info"
                                />
                            )}
                        </StackItem>
                        <IncompatibleIntegrationsBanner />
                    </ContentSection>
                )
            )}
        </SuspenseBoundary>
    );
};
